import Vue from 'vue'
import Router from 'vue-router'
import cookie from 'js-cookie'
import { APPID, whiteList } from '@/config'
import redirectUri from '@/utils/_redirect'
import { clearStorage } from '@/utils'

Vue.use(Router)

// 自动扫描 modules 下的路由模块
const files = require.context('./modules/', true, /\.js$/)
const routes = []
files.keys().forEach(key => {
  let file = files(key).default
  if (Array.isArray(file)) {
    routes.push(...file)
  } else {
    routes.push(file)
  }
})

let router = new Router({
  mode: 'hash',
  base: '/',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'VIPKID数学思维'
  if (!whiteList.has(to.name)) {
    // const openId = cookie.get(`openId_vweixin_${APPID}`)
    const parentId = cookie.get('mbparentid')
    // if (openId && parentId) {
    if (parentId) {
      next()
    } else {
      cookie.remove('mbparentid')
      cookie.remove('mbstudentid')
      cookie.remove(`openId_vweixin_${APPID}`)
      clearStorage()
      window.location.href = redirectUri(to.path)
    }
  } else {
    next()
  }
})

export default router
